/**
 * NGAP Maroc - All codes
 * Source: Arrêté 177-06 (NGAP Générale) + Arrêté 1796-03 (Biologie)
 */
import raw from "./ngap-maroc-codes.json";

export interface NGAPAct {
  code: string;
  label: string;
  title?: string | null;
  chapitre?: string | null;
  article?: string | null;
  specialty: string;
  sub_specialty?: string | null;
  type: string;
  coefficient: number;
  secondary_coefficient?: number;
  source: string;
  source_page?: number;
}

export const NGAP_MAROC: NGAPAct[] = raw as NGAPAct[];

export const NGAP_BY_SPECIALTY: Record<string, NGAPAct[]> = NGAP_MAROC.reduce(
  (acc, act) => {
    (acc[act.specialty] ||= []).push(act);
    return acc;
  },
  {} as Record<string, NGAPAct[]>,
);

export function findNGAPByCode(code: string): NGAPAct | undefined {
  return NGAP_MAROC.find((a) => a.code === code);
}

export function ngapBySpecialty(specialty: string): NGAPAct[] {
  return NGAP_BY_SPECIALTY[specialty] || [];
}
